var _style, _path, _path2, _defs, _path3, _defs2, _defs3, _defs4, _path4, _defs5, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLowerBanner = function SvgLowerBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 1600 280"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".lower-banner_svg__st18{opacity:.8;fill:#1a1a1a}.lower-banner_svg__st20{fill:none;stroke:#38b8fe;stroke-width:2;stroke-miterlimit:10}.lower-banner_svg__st38{clip-path:url(#lower-banner_svg__XMLID_12_)}.lower-banner_svg__st48{enable-background:new}.lower-banner_svg__st50{stroke-width:.25}.lower-banner_svg__st50,.lower-banner_svg__st57{fill:none;stroke:#f29e1f;stroke-miterlimit:10}.lower-banner_svg__st59{display:none}.lower-banner_svg__st59,.lower-banner_svg__st60,.lower-banner_svg__st71{fill:none;stroke:#f29e1f;stroke-linejoin:round;stroke-miterlimit:33}.lower-banner_svg__st71{stroke:#05a6fe;stroke-width:.5}.lower-banner_svg__st72{fill:#a26509}")), /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__BG_Elements"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__circle-1_1_",
    x1: 79.139,
    x2: 159.411,
    y1: 57.871,
    y2: 57.871,
    gradientTransform: "rotate(18.904 86.354 75.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "lower-banner_svg__circle-1",
    cx: 123.1,
    cy: 69.5,
    r: 40.1,
    style: {
      fill: "url(#lower-banner_svg__circle-1_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__circle-2_1_",
    x1: 1460.481,
    x2: 1556.273,
    y1: 217.327,
    y2: 217.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "lower-banner_svg__circle-2",
    cx: 1508.4,
    cy: 217.3,
    r: 47.9,
    style: {
      fill: "url(#lower-banner_svg__circle-2_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__circle-3_1_",
    x1: 1131.176,
    x2: 1270.28,
    y1: 193.996,
    y2: 193.996,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e4637b",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#dc3856",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#dc3856",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#941a30",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#941a30",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#530f1b",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "lower-banner_svg__circle-3",
    cx: 1200.7,
    cy: 88,
    r: 69.6,
    style: {
      fill: "url(#lower-banner_svg__circle-3_1_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__grid"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_1_",
    x1: 1573.898,
    x2: 40.487,
    y1: 137.225,
    y2: 137.225,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 144.8h1533.4",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_1_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_2_",
    x1: 1604.028,
    x2: 10.357,
    y1: 118.864,
    y2: 118.864,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 163.1H1604",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_2_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_3_",
    x1: 1636.624,
    x2: -22.239,
    y1: 99.001,
    y2: 99.001,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-22.2 183h1658.8",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_3_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_4_",
    x1: 1672,
    x2: -57.615,
    y1: 77.443,
    y2: 77.443,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-57.6 204.6H1672",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_4_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_5_",
    x1: 1710.528,
    x2: -96.142,
    y1: 53.964,
    y2: 53.964,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-96.1 228h1806.6",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_5_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_6_",
    x1: 1752.648,
    x2: -138.263,
    y1: 28.296,
    y2: 28.296,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-138.3 253.7h1890.9",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_6_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_7_",
    x1: 1798.889,
    x2: -184.504,
    y1: 0.117,
    y2: 0.117,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-184.5 281.9h1983.4",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_7_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_8_",
    x1: 214.13,
    x2: 214.13,
    y1: -49.889,
    y2: 163.613,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.1 119 99.2 331.3",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_8_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_9_",
    x1: 411.817,
    x2: 411.817,
    y1: -49.769,
    y2: 163.493,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M488.5 119 335.2 331.3",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_9_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_10_",
    x1: 609.505,
    x2: 609.505,
    y1: -49.571,
    y2: 163.295,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m647.8 119-76.6 212.3",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_10_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_11_",
    x1: 807.192,
    x2: 807.192,
    y1: -49.298,
    y2: 163.021,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M807.2 119v212.3",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_11_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_12_",
    x1: 1004.88,
    x2: 1004.88,
    y1: -49.571,
    y2: 163.295,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m966.6 119 76.6 212.3",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_12_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_13_",
    x1: 1202.568,
    x2: 1202.568,
    y1: -49.769,
    y2: 163.493,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1125.9 119 153.3 212.3",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_13_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_14_",
    x1: 1400.255,
    x2: 1400.255,
    y1: -49.889,
    y2: 163.613,
    gradientTransform: "matrix(1 0 0 -1 0 282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1285.3 119 229.9 212.3",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_14_)",
      strokeWidth: 1.6107
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__frames"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__frame-5-files"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1460.6 169.7h-230.1c-6.6 0-12-5.4-12-12v-89c0-6.6 5.4-12 12-12h230.1c6.6 0 12 5.4 12 12v89c0 6.6-5.4 12-12 12",
    className: "lower-banner_svg__st18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_15_",
    x1: 1257.342,
    x2: 1433.845,
    y1: 24.928,
    y2: 201.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ddcff",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#38b8fe",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1460.6 169.7h-230.1c-6.6 0-12-5.4-12-12v-89c0-6.6 5.4-12 12-12h230.1c6.6 0 12 5.4 12 12v89c0 6.6-5.4 12-12 12",
    style: {
      fill: "url(#lower-banner_svg__SVGID_15_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1460.6 169.7h-230.1c-6.6 0-12-5.4-12-12v-89c0-6.6 5.4-12 12-12h230.1c6.6 0 12 5.4 12 12v89c0 6.6-5.4 12-12 12z",
    className: "lower-banner_svg__st20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_16_",
    x1: 1238.649,
    x2: 1272.156,
    y1: 118.986,
    y2: 152.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1267 154.6h-23.1c-4.1 0-7.4-3.3-7.4-7.4v-23.1c0-4.1 3.3-7.4 7.4-7.4h23.1c4.1 0 7.4 3.3 7.4 7.4v23.1c-.1 4.2-3.4 7.4-7.4 7.4",
    style: {
      fill: "url(#lower-banner_svg__SVGID_16_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_17_",
    x1: 1298.776,
    x2: 1332.283,
    y1: 118.986,
    y2: 152.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1327.1 154.6H1304c-4.1 0-7.4-3.3-7.4-7.4v-23.1c0-4.1 3.3-7.4 7.4-7.4h23.1c4.1 0 7.4 3.3 7.4 7.4v23.1c-.1 4.2-3.4 7.4-7.4 7.4",
    style: {
      fill: "url(#lower-banner_svg__SVGID_17_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_18_",
    x1: 1358.904,
    x2: 1392.411,
    y1: 118.986,
    y2: 152.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1387.2 154.6h-23.1c-4.1 0-7.4-3.3-7.4-7.4v-23.1c0-4.1 3.3-7.4 7.4-7.4h23.1c4.1 0 7.4 3.3 7.4 7.4v23.1c0 4.2-3.3 7.4-7.4 7.4",
    style: {
      fill: "url(#lower-banner_svg__SVGID_18_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_19_",
    x1: 1419.032,
    x2: 1452.539,
    y1: 118.986,
    y2: 152.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1447.3 154.6h-23.1c-4.1 0-7.4-3.3-7.4-7.4v-23.1c0-4.1 3.3-7.4 7.4-7.4h23.1c4.1 0 7.4 3.3 7.4 7.4v23.1c0 4.2-3.3 7.4-7.4 7.4",
    style: {
      fill: "url(#lower-banner_svg__SVGID_19_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_20_",
    x1: 1238.649,
    x2: 1272.156,
    y1: 73.866,
    y2: 107.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1267 109.5h-23.1c-4.1 0-7.4-3.3-7.4-7.4v-23c0-4.1 3.3-7.4 7.4-7.4h23.1c4.1 0 7.4 3.3 7.4 7.4v23.1c-.1 4-3.4 7.3-7.4 7.3",
    style: {
      fill: "url(#lower-banner_svg__SVGID_20_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_21_",
    x1: 1298.776,
    x2: 1332.283,
    y1: 73.866,
    y2: 107.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1327.1 109.5H1304c-4.1 0-7.4-3.3-7.4-7.4v-23c0-4.1 3.3-7.4 7.4-7.4h23.1c4.1 0 7.4 3.3 7.4 7.4v23.1c-.1 4-3.4 7.3-7.4 7.3",
    style: {
      fill: "url(#lower-banner_svg__SVGID_21_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_22_",
    x1: 1358.904,
    x2: 1392.411,
    y1: 73.866,
    y2: 107.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1387.2 109.5h-23.1c-4.1 0-7.4-3.3-7.4-7.4v-23c0-4.1 3.3-7.4 7.4-7.4h23.1c4.1 0 7.4 3.3 7.4 7.4v23.1c0 4-3.3 7.3-7.4 7.3",
    style: {
      fill: "url(#lower-banner_svg__SVGID_22_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_23_",
    x1: 1419.032,
    x2: 1452.539,
    y1: 73.866,
    y2: 107.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1447.3 109.5h-23.1c-4.1 0-7.4-3.3-7.4-7.4v-23c0-4.1 3.3-7.4 7.4-7.4h23.1c4.1 0 7.4 3.3 7.4 7.4v23.1c0 4-3.3 7.3-7.4 7.3",
    style: {
      fill: "url(#lower-banner_svg__SVGID_23_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__frame-4-waves"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lower-banner_svg__XMLID_6_",
    d: "M1165.9 149.1h-154.7c-6.6 0-12-5.4-12-12V49.3c0-6.6 5.4-12 12-12h154.7c6.6 0 12 5.4 12 12v87.8c0 6.6-5.4 12-12 12"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "lower-banner_svg__XMLID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__XMLID_6_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#lower-banner_svg__XMLID_8_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__XMLID_1_"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.9 149.1h-154.7c-6.6 0-12-5.4-12-12V49.3c0-6.6 5.4-12 12-12h154.7c6.6 0 12 5.4 12 12v87.8c0 6.6-5.4 12-12 12",
    className: "lower-banner_svg__st18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_24_",
    x1: 1019.423,
    x2: 1157.652,
    y1: 24.063,
    y2: 162.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ddcff",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#38b8fe",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1165.9 149.1h-154.7c-6.6 0-12-5.4-12-12V49.3c0-6.6 5.4-12 12-12h154.7c6.6 0 12 5.4 12 12v87.8c0 6.6-5.4 12-12 12",
    style: {
      fill: "url(#lower-banner_svg__SVGID_24_)"
    }
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lower-banner_svg__XMLID_3_",
    d: "M1164.5 143.2h-152.1c-3.8 0-6.8-3.1-6.8-6.8V52.2h165.7v84.1c0 3.8-3 6.9-6.8 6.9"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lower-banner_svg__XMLID_2_",
    d: "M1164.5 143.2h-152.1c-3.8 0-6.8-3.1-6.8-6.8V52.2h165.7v84.1c0 3.8-3 6.9-6.8 6.9"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__XMLID_3_",
    style: {
      overflow: "visible",
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__XMLID_9_",
    x1: 1025.291,
    x2: 1151.617,
    y1: 32.526,
    y2: 158.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__XMLID_2_",
    style: {
      overflow: "visible",
      fill: "url(#lower-banner_svg__XMLID_9_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "lower-banner_svg__XMLID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__XMLID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lower-banner_svg__XMLID_11_",
    style: {
      clipPath: "url(#lower-banner_svg__XMLID_10_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__XMLID_2_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_25_",
    x1: 1033.218,
    x2: 1112.492,
    y1: 91.59,
    y2: 170.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e4637b",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#dc3856",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#dc3856",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#941a30",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#941a30",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#530f1b",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1002.2 134.1c25.4-43.7 40.5-52.4 49.9-50.3 17.9 3.9 19.2 46.9 40 50.3 9.1 1.5 12.4-11.4 25.5-13.2 12.4-1.7 23.9 5.9 31.7 13.2",
    style: {
      clipPath: "url(#lower-banner_svg__XMLID_11_)",
      fill: "url(#lower-banner_svg__SVGID_25_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_26_",
    x1: 1077.883,
    x2: 1154.757,
    y1: 93.989,
    y2: 170.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1044.5 134.1c20.1-32.9 34.7-39.9 45-38.7 21.8 2.4 34.6 42.1 44.9 38.7 7-2.3 2.6-21 11.3-26 9.5-5.4 28.7 9.4 45.9 26",
    style: {
      clipPath: "url(#lower-banner_svg__XMLID_11_)",
      fill: "url(#lower-banner_svg__SVGID_26_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_27_",
    x1: 999.183,
    x2: 1177.892,
    y1: 52.23,
    y2: 52.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M999.2 52.2h178.7",
    style: {
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_27_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_28_",
    x1: 1154.433,
    x2: 1158.402,
    y1: 43.755,
    y2: 47.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1156.4 48.5c-1.5 0-2.8-1.3-2.8-2.8s1.3-2.8 2.8-2.8 2.8 1.3 2.8 2.8c0 1.6-1.2 2.8-2.8 2.8",
    style: {
      fill: "url(#lower-banner_svg__SVGID_28_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_29_",
    x1: 1161.885,
    x2: 1165.853,
    y1: 43.755,
    y2: 47.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1163.9 48.5c-1.5 0-2.8-1.3-2.8-2.8s1.3-2.8 2.8-2.8 2.8 1.3 2.8 2.8c0 1.6-1.3 2.8-2.8 2.8",
    style: {
      fill: "url(#lower-banner_svg__SVGID_29_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_30_",
    x1: 1169.336,
    x2: 1173.305,
    y1: 43.755,
    y2: 47.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1171.3 48.5c-1.5 0-2.8-1.3-2.8-2.8s1.3-2.8 2.8-2.8 2.8 1.3 2.8 2.8c0 1.6-1.2 2.8-2.8 2.8",
    style: {
      fill: "url(#lower-banner_svg__SVGID_30_)"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__XMLID_6_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#38b8fe",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__frame-3-globe"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lower-banner_svg__XMLID_4_",
    d: "M936.6 222.1H642.2c-6.6 0-12-5.4-12-12V34.8c0-6.6 5.4-12 12-12h294.4c6.6 0 12 5.4 12 12v175.3c0 6.6-5.4 12-12 12"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "lower-banner_svg__XMLID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__XMLID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "lower-banner_svg__st38"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M936.6 222.1H642.2c-6.6 0-12-5.4-12-12V34.8c0-6.6 5.4-12 12-12h294.4c6.6 0 12 5.4 12 12v175.3c0 6.6-5.4 12-12 12",
    className: "lower-banner_svg__st18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_31_",
    x1: 663.529,
    x2: 915.322,
    y1: -3.412,
    y2: 248.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ddcff",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#38b8fe",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M936.6 222.1H642.2c-6.6 0-12-5.4-12-12V34.8c0-6.6 5.4-12 12-12h294.4c6.6 0 12 5.4 12 12v175.3c0 6.6-5.4 12-12 12",
    style: {
      fill: "url(#lower-banner_svg__SVGID_31_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "lower-banner_svg__st38"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_32_",
    x1: 889.029,
    x2: 925.156,
    y1: 79.454,
    y2: 115.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M927.6 108.6h-41c-6.1 0-11-4.9-11-11s4.9-11 11-11h41c6.1 0 11 4.9 11 11 0 6-4.9 11-11 11",
    style: {
      fill: "url(#lower-banner_svg__SVGID_32_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_33_",
    x1: 889.029,
    x2: 925.156,
    y1: 106.937,
    y2: 143.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M927.6 136h-41c-6.1 0-11-4.9-11-11s4.9-11 11-11h41c6.1 0 11 4.9 11 11s-4.9 11-11 11",
    style: {
      fill: "url(#lower-banner_svg__SVGID_33_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_34_",
    x1: 881.813,
    x2: 903.508,
    y1: 141.637,
    y2: 163.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M898.7 163.5h-12.2c-6.1 0-11-4.9-11-11s4.9-11 11-11h12.2c6.1 0 11 4.9 11 11 .1 6.1-4.9 11-11 11",
    style: {
      fill: "url(#lower-banner_svg__SVGID_34_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "lower-banner_svg__st38"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_35_",
    x1: 657.847,
    x2: 849.344,
    y1: 33.316,
    y2: 224.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M860.6 211.5h-214c-2.8 0-5-2.2-5-5v-157h223.9v157c.1 2.8-2.2 5-4.9 5",
    style: {
      fill: "url(#lower-banner_svg__SVGID_35_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_36_",
    x1: 670.376,
    x2: 721.695,
    y1: 40.9,
    y2: 92.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M649.1 62.2h94v8.7h-94z",
    style: {
      fill: "url(#lower-banner_svg__SVGID_36_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_37_",
    x1: 660.163,
    x2: 691.057,
    y1: 66.688,
    y2: 97.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M649.1 77.8h53.1v8.7h-53.1z",
    style: {
      fill: "url(#lower-banner_svg__SVGID_37_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_38_",
    x1: 653.525,
    x2: 671.142,
    y1: 88.709,
    y2: 106.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M649.1 93.2h26.6v8.7h-26.6z",
    style: {
      fill: "url(#lower-banner_svg__SVGID_38_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_39_",
    x1: 787.385,
    x2: 719.861,
    y1: 96.763,
    y2: 164.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 121.5c-.8-4.1-2-7.3-2-7.4-.4-1-1-2.4-1.4-3.5-.5-1-1.1-2.4-1.7-3.4-.4-.6-.8-1.2-1.2-1.9 0-.1-.1-.3-.2-.4-.9-1.3-1.8-2.7-2.6-3.8-.7-.9-1.7-2-2.4-2.9 0 0-2.2-2.5-5.4-5.1-2.9-2.3-5.3-3.7-6.2-4.2-.3-.1-.6-.3-.9-.5-.1 0-.1-.1-.2-.1-.7-.4-1.5-.8-2.1-1.1-1.2-.5-2.7-1.2-4-1.7-.9-.3-2.2-.8-3.2-1-.4-.1-.9-.2-1.3-.3-1-.3-1.9-.5-2.9-.7-.2 0-.3-.1-.5-.1s-.4-.1-.5-.1c-.3 0-.5-.1-.8-.1-1.8-.3-3.6-.5-5.3-.5h-1.5c-2.3 0-3.9.1-5.2.3-1.5.1-2.9.3-4.4.7-.3.1-.6.1-1 .2-.2 0-.3.1-.5.1-.1 0-.2 0-.3.1-1.1.2-2.2.5-2.7.7-1.2.3-1.7.5-3.2 1.1-.9.3-2.1.9-3 1.3-.5.3-1 .5-1.5.7-.1.1-.3.1-.4.2-2.1 1.1-3.6 2-4.4 2.5-1.4.9-3.3 2.3-5.8 4.5-1.1 1-3.1 2.9-5.1 5.3-1.1 1.3-2.6 3.4-4.2 6.1-.2.3-.4.7-.6 1.1-.4.7-.8 1.5-1.1 2.2-.5 1-1 2.4-1.5 3.4 0 0-1.3 3.2-2.2 7.2-.2 1.1-.5 2.6-.7 3.8-.2 1.1-.3 2.7-.4 3.8-.1 1.4-.1 3.4 0 4.8.1 1.2.2 2.7.3 3.9s.4 2.7.6 3.8.6 2.6.9 3.7c.4 1.1.8 2.5 1.2 3.6s1 2.5 1.5 3.5 1.2 2.3 1.7 3.3c.6 1 1.4 2.2 2 3.2 2.3 3.3 4.6 5.7 4.7 5.8 1.5 1.6 3.7 3.6 5.4 4.9 2.5 2 4.1 2.9 6.2 4.1 1.1.6 2.5 1.3 3.6 1.8.9.4 2.3.9 3.2 1.3 1.4.6 3.4 1.1 4.9 1.5.4.1.9.2 1.4.3h.1c.5.1.9.2 1.4.3.2 0 .4.1.6.1h.2c.9.2 2 .3 3.2.4.7.1 1.5.1 2.6.2h3.3s.6 0 1.5-.1c.2 0 .9-.1 1.9-.2.9-.1 1.8-.2 2.7-.4.9-.1 1.9-.3 2.9-.5 1.5-.3 2.3-.6 3.7-1 .8-.2 1.9-.6 2.7-.9.7-.3 1.6-.7 2.5-1 0 0 .1 0 .1-.1l.6-.3c.4-.2.8-.4 1.3-.6.1 0 .1-.1.2-.1.6-.3 1.1-.6 1.6-.9.1 0 .2-.1.3-.2 1.1-.6 3.3-1.9 5.8-3.9 1-.8 3.1-2.4 5.4-4.9 2.5-2.7 4.2-5.1 4.6-5.7 1-1.5 2.3-3.5 3.7-6.4.4-.9 1.7-3.6 2.7-7 .6-2.1 1.3-5 1.5-7.1.3-2.3.4-5.4.4-7.7.3-.6.2-3.8-.6-8",
    style: {
      fill: "url(#lower-banner_svg__SVGID_39_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "lower-banner_svg__st48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "lower-banner_svg__st48"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lower-banner_svg__SVGID_40_",
    d: "M801.4 129.3c0 2.3-.1 5.4-.4 7.7-.3 2.2-.9 5-1.5 7.1-1 3.4-2.3 6.1-2.7 7-1.4 2.9-2.7 4.9-3.7 6.4-.4.7-2.1 3.1-4.6 5.7-2.4 2.5-4.4 4.2-5.4 4.9-2.7 2.1-5.2 3.5-6.1 4s-2.2 1.2-3.1 1.6-2.2.9-3.2 1.3c-.8.3-1.9.7-2.7.9-1.4.4-2.2.7-3.7 1-3.9.8-7.2 1.1-7.5 1.1-.9.1-1.5.1-1.5.1h-1.9c-1.7 0-2.9-.1-3.9-.2-1.7-.1-2.9-.4-4.1-.6-.9-.1-2-.4-2.9-.6-1.5-.3-3.5-.9-4.9-1.5-1-.4-2.3-.9-3.2-1.3-1.1-.5-2.6-1.2-3.6-1.8-2.1-1.2-3.7-2.1-6.2-4.1-1.7-1.3-3.9-3.3-5.4-4.9-.1-.1-2.4-2.4-4.7-5.8-.6-.9-1.4-2.2-2-3.2s-1.2-2.3-1.7-3.3-1.1-2.4-1.5-3.5-.8-2.5-1.2-3.6-.7-2.6-.9-3.7-.5-2.7-.6-3.8c-.1-1.2-.2-2.7-.3-3.9-.1-1.4-.1-3.4 0-4.8.1-1.2.2-2.7.4-3.8s.4-2.6.7-3.8c.9-4 2.2-7.2 2.2-7.2.4-1 1-2.4 1.5-3.4s1.2-2.3 1.8-3.3c1.6-2.7 3.1-4.7 4.2-6.1 2-2.5 3.9-4.3 5.1-5.3 2.5-2.2 4.4-3.5 5.8-4.5 1-.7 3.1-2 6.3-3.5.9-.4 2.1-.9 3-1.3 1.5-.6 2-.7 3.2-1.1.6-.2 2.2-.6 3.5-.9 1.7-.3 2.7-.5 4.4-.8 1.4-.2 3.3-.4 6.2-.4 2.7 0 5.4.3 8.2.8 19.9 3.7 35.2 21.8 35.8 44.4.7 26.2-18.7 48.7-43.3 50.2 24.6-1.4 44-23.9 43.3-50.2-.6-22.6-15.9-40.7-35.8-44.4 1.4.3 3.3.7 4.7 1.1 1 .3 2.2.7 3.2 1 1.2.4 2.8 1.1 4 1.7 1 .5 2.2 1.1 3.2 1.7.9.5 3.3 1.9 6.2 4.2 3.2 2.6 5.4 5.1 5.4 5.1.7.9 1.8 1.9 2.4 2.9 1.3 1.8 2.9 4.2 4.1 6.1.6 1 1.2 2.3 1.7 3.4.5 1 1 2.4 1.4 3.5 0 0 1.2 3.2 2 7.4.2 4.7.3 7.9.3 8.3",
    className: "lower-banner_svg__st48"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "lower-banner_svg__SVGID_41_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__SVGID_40_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#lower-banner_svg__SVGID_41_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c24.6-1.4 44-23.9 43.3-50.2 9.5 1.8-2.7 4.4-27.3 5.8.7 26.3-6.5 46.2-16 44.4z",
    className: "lower-banner_svg__st50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M777.1 170.3c4.8.9-1.3 2.2-13.7 2.9M792.7 152.3c8.2 1.5-2.3 3.8-23.5 5",
    className: "lower-banner_svg__st50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c26-.3 46.6-22 45.9-48.2",
    className: "lower-banner_svg__st50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c20.6.8 36.8-19.9 36.1-46.1",
    className: "lower-banner_svg__st50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c9.5 1.8 16.7-18.1 16-44.4-24.6 1.4-52.3 1.1-61.8-.6.7 26.2 21.2 46.4 45.8 45z",
    className: "lower-banner_svg__st50"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M763.4 173.2c-12.4.7-26.4.6-31.2-.3M769.1 157.3c-21.2 1.2-45.1 1-53.3-.5",
    className: "lower-banner_svg__st50"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c-4.2 2.2-8.1-17.3-8.8-43.5",
    className: "lower-banner_svg__st50"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c-16.4 2.1-30.3-17.5-31-43.8",
    className: "lower-banner_svg__st50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c-24.6 1.4-45.1-18.8-45.8-45-9.5-1.8 2.7-4.4 27.3-5.8.6 26.3 8.9 49.1 18.5 50.8z",
    className: "lower-banner_svg__st50"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M732.2 172.9c-4.8-.9 1.3-2.2 13.7-2.9M715.8 156.8c-8.2-1.5 2.3-3.8 23.5-5",
    className: "lower-banner_svg__st50"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c-26 .3-47.7-20.7-48.4-47",
    className: "lower-banner_svg__st50"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c-20.6-.8-37.9-22.8-38.6-49.1",
    className: "lower-banner_svg__st50"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c-9.5-1.8-17.8-24.5-18.5-50.8 24.6-1.4 52.3-1.1 61.8.6.6 26.3-18.8 48.8-43.3 50.2z",
    className: "lower-banner_svg__st50"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M746 170c12.4-.7 26.4-.6 31.2.3M739.3 151.8c21.2-1.2 45.1-1 53.3.5",
    className: "lower-banner_svg__st50"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c4.2-2.2 7-25.4 6.3-51.7",
    className: "lower-banner_svg__st50"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M754.9 178.1c16.4-2.1 29.2-25.2 28.5-51.4",
    className: "lower-banner_svg__st50"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M798.1 128c-.7-26.2-21.2-46.4-45.8-45 9.5 1.8 17.8 24.6 18.5 50.8 24.7-1.5 36.9-4.1 27.3-5.8z",
    className: "lower-banner_svg__st50"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M791.4 104.3c8.2 1.5-2.3 3.8-23.5 5M775 88.1c4.8.9-1.3 2.2-13.7 2.9",
    className: "lower-banner_svg__st50"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M800.8 129.9c-.7-26.2-22.4-47.3-48.4-47",
    className: "lower-banner_svg__st50"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M791 132c-.7-26.2-18-48.3-38.6-49.1",
    className: "lower-banner_svg__st50"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M770.9 133.7c-.7-26.2-9-49-18.5-50.8-24.6 1.4-44 23.9-43.3 50.2 9.5 1.8 37.2 2.1 61.8.6z",
    className: "lower-banner_svg__st50"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M767.9 109.3c-21.2 1.2-45.1 1-53.3-.5M761.2 91.1c-12.4.7-26.4.6-31.2-.3",
    className: "lower-banner_svg__st50"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M746.1 134.6c-.7-26.2 2.1-49.4 6.3-51.7",
    className: "lower-banner_svg__st50"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M723.9 134.4c-.7-26.2 12.1-49.3 28.5-51.4",
    className: "lower-banner_svg__st50"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M709.1 133.1c-.7-26.2 18.7-48.7 43.3-50.2-9.5-1.8-16.7 18.2-16 44.4-24.6 1.5-36.8 4-27.3 5.8z",
    className: "lower-banner_svg__st50"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M714.6 108.7c-8.2-1.5 2.3-3.8 23.5-5M730.1 90.7c-4.8-.9 1.3-2.2 13.7-2.9",
    className: "lower-banner_svg__st50"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M706.5 131.1c-.7-26.2 19.9-47.9 45.9-48.2",
    className: "lower-banner_svg__st50"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M716.2 129.1c-.7-26.2 15.5-46.9 36.1-46.1",
    className: "lower-banner_svg__st50"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M736.4 127.3c-.7-26.2 6.5-46.2 16-44.4 24.6-1.4 45.1 18.8 45.8 45-9.6-1.7-37.3-2-61.8-.6z",
    className: "lower-banner_svg__st50"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M738.1 103.8c21.2-1.2 45.1-1 53.3.5M743.8 87.8c12.4-.7 26.4-.6 31.2.3",
    className: "lower-banner_svg__st50"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M761.2 126.5c-.7-26.2-4.6-45.8-8.8-43.5",
    className: "lower-banner_svg__st50"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M783.3 126.7c-.7-26.2-14.6-45.9-31-43.8",
    className: "lower-banner_svg__st50"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M801.4 129.3c0 2.3-.1 5.4-.4 7.7-.3 2.2-.9 5-1.5 7.1-1 3.4-2.3 6.1-2.7 7-1.4 2.9-2.7 4.9-3.7 6.4-.4.7-2.1 3.1-4.6 5.7-2.4 2.5-4.4 4.2-5.4 4.9-2.7 2.1-5.2 3.5-6.1 4s-2.2 1.2-3.1 1.6-2.2.9-3.2 1.3c-.8.3-1.9.7-2.7.9-1.4.4-2.2.7-3.7 1-3.9.8-7.2 1.1-7.5 1.1-.9.1-1.5.1-1.5.1h-1.9c-1.7 0-2.9-.1-3.9-.2-1.7-.1-2.9-.4-4.1-.6-.9-.1-2-.4-2.9-.6-1.5-.3-3.5-.9-4.9-1.5-1-.4-2.3-.9-3.2-1.3-1.1-.5-2.6-1.2-3.6-1.8-2.1-1.2-3.7-2.1-6.2-4.1-1.7-1.3-3.9-3.3-5.4-4.9-.1-.1-2.4-2.4-4.7-5.8-.6-.9-1.4-2.2-2-3.2s-1.2-2.3-1.7-3.3-1.1-2.4-1.5-3.5-.8-2.5-1.2-3.6-.7-2.6-.9-3.7-.5-2.7-.6-3.8c-.1-1.2-.2-2.7-.3-3.9-.1-1.4-.1-3.4 0-4.8.1-1.2.2-2.7.4-3.8s.4-2.6.7-3.8c.9-4 2.2-7.2 2.2-7.2.4-1 1-2.4 1.5-3.4s1.2-2.3 1.8-3.3c1.6-2.7 3.1-4.7 4.2-6.1 2-2.5 3.9-4.3 5.1-5.3 2.5-2.2 4.4-3.5 5.8-4.5 1-.7 3.1-2 6.3-3.5.9-.4 2.1-.9 3-1.3 1.5-.6 2-.7 3.2-1.1.6-.2 2.2-.6 3.5-.9 1.7-.3 2.7-.5 4.4-.8 1.4-.2 3.3-.4 6.2-.4 2.7 0 5.4.3 8.2.8 19.9 3.7 35.2 21.8 35.8 44.4.7 26.2-18.7 48.7-43.3 50.2 24.6-1.4 44-23.9 43.3-50.2-.6-22.6-15.9-40.7-35.8-44.4 1.4.3 3.3.7 4.7 1.1 1 .3 2.2.7 3.2 1 1.2.4 2.8 1.1 4 1.7 1 .5 2.2 1.1 3.2 1.7.9.5 3.3 1.9 6.2 4.2 3.2 2.6 5.4 5.1 5.4 5.1.7.9 1.8 1.9 2.4 2.9 1.3 1.8 2.9 4.2 4.1 6.1.6 1 1.2 2.3 1.7 3.4.5 1 1 2.4 1.4 3.5 0 0 1.2 3.2 2 7.4.2 4.7.3 7.9.3 8.3z",
    style: {
      clipPath: "url(#lower-banner_svg__SVGID_41_)",
      fill: "none",
      stroke: "#f29e1f",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__SVGID_40_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#f29e1f",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    }
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_42_",
    x1: 630.223,
    x2: 948.628,
    y1: 49.529,
    y2: 49.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#593805"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#a26509"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#a26509"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M630.2 49.5h318.4",
    style: {
      clipPath: "url(#lower-banner_svg__XMLID_12_)",
      fill: "none",
      stroke: "url(#lower-banner_svg__SVGID_42_)",
      strokeWidth: 1.6107
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "lower-banner_svg__st38"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_43_",
    x1: 906.832,
    x2: 913.903,
    y1: 34.429,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M910.4 43c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5c0 2.7-2.3 5-5 5",
    style: {
      fill: "url(#lower-banner_svg__SVGID_43_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_44_",
    x1: 920.108,
    x2: 927.179,
    y1: 34.429,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M923.6 43c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5c0 2.7-2.2 5-5 5",
    style: {
      fill: "url(#lower-banner_svg__SVGID_44_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_45_",
    x1: 933.385,
    x2: 940.456,
    y1: 34.429,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f29e1f",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#a26509",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593805",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M936.9 43c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5c0 2.7-2.2 5-5 5",
    style: {
      fill: "url(#lower-banner_svg__SVGID_45_)"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lower-banner_svg__XMLID_4_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#38b8fe",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__frame-2-text"
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M561.8 201.2H353c-6.6 0-12-5.4-12-12V67.5c0-6.6 5.4-12 12-12h208.8c6.6 0 12 5.4 12 12v121.7c0 6.6-5.4 12-12 12",
    className: "lower-banner_svg__st18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_46_",
    x1: 366.26,
    x2: 548.458,
    y1: 37.204,
    y2: 219.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ddcff",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#38b8fe",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M561.8 201.2H353c-6.6 0-12-5.4-12-12V67.5c0-6.6 5.4-12 12-12h208.8c6.6 0 12 5.4 12 12v121.7c0 6.6-5.4 12-12 12",
    style: {
      fill: "url(#lower-banner_svg__SVGID_46_)"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M561.8 201.2H353c-6.6 0-12-5.4-12-12V67.5c0-6.6 5.4-12 12-12h208.8c6.6 0 12 5.4 12 12v121.7c0 6.6-5.4 12-12 12z",
    className: "lower-banner_svg__st20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M399.7 65.9h19.2M423.5 65.9H452M455.3 65.9h17.1M476.3 65.9H508M513.3 65.9h52.8M365.3 70.6h30M399.7 70.6h21.2M425.5 70.6h25.4M456.1 70.6h47.1M370.5 75.2h40.1M413 75.2h23.9M440.2 75.2h17M459.9 75.2h31.5M366.8 84.4h19.7M387.6 84.4h34.6M424.4 84.4h36.1M463.2 84.4h18.6M484.6 84.4H512M513.5 84.4h26.1M375.9 89.1h25.5M404.4 89.1h24.1M431 89.1h22.7M456 89.1h18.5M476.8 89.1h19.6M364 93.7h19M386 93.7h13.5M402.7 93.7h13.1M418.5 93.7h14.2M435.9 93.7H454M366.9 98.3h13.5M383.6 98.3h18.5M426.1 98.3h-20.9M367.9 102.9h17.2M387.4 102.9h19.9M369.9 107.6h9.5M376.6 116.8h10.6M388.6 116.8h23.2M413.9 116.8h16.9M431.7 116.8h15.7M448.9 116.8h15.2M406.3 121.4h34.6M442.6 121.4h41.8M486 121.4h33M544 135.1h16.7M499.4 135.1h42.2M466.8 135.1h29.5M441.4 135.1h21.4M397.1 135.1h39.6M374.7 135.1h19.2M544 139.7h14.3M528.9 139.7h11.9M498.6 139.7h27.9M465.4 139.7h30.1M436.6 139.7H463M408.5 139.7h25M376.8 139.7h28.5M529.4 149h26.3M447.6 149h78.6M410.2 149h34.2M380.1 149h27.7M541.3 153.5h14.4M529.3 153.5h8M510.1 153.5h16.8M479.6 153.5H507M446.9 153.5h29.5M409.7 153.5h34.1M393.8 153.5h12.7M378.6 153.5h12M521.4 163.3h23M495.9 163.3h22.3M466.4 163.3h27.1M400.2 163.3h63.9M381.9 163.3h15.9M437.2 167.8h108.1M400.2 167.8H434M372.7 167.8h25.1M529.5 172.5h16.7M500.2 172.5h26.2M432.3 172.5h64.8M405.1 172.5H430M368.1 172.5h34.7M398.9 177h39.7M371.9 177h24.6M359.3 177h10.3M346.2 65.9h50.4M346.2 70.6h16.2M346.2 75.2h22.1M346.2 84.4h19.3M346.2 89.1h26.1M346.2 93.7h14.7M346.2 98.3h16.1M346.2 102.9h17.2M346.2 107.6h20.4M357.7 116.8h13M357.7 121.4h46.2M357.7 126.1h33.5M357.7 135.1h14.5M357.7 139.7h16.8M357.7 149h20M357.7 153.5h18.6M346.2 163.3h33.3M346.2 167.8h24.4M346.2 172.5h19.6M346.2 177h10.3",
    className: "lower-banner_svg__st57"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__frame-1-3d"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 250.6h-147c-6.6 0-12-5.4-12-12v-83c0-6.6 5.4-12 12-12h147c6.6 0 12 5.4 12 12v83c0 6.6-5.4 12-12 12",
    className: "lower-banner_svg__st18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_47_",
    x1: 121.144,
    x2: 253.115,
    y1: 131.145,
    y2: 263.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ddcff",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#38b8fe",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.6 250.6h-147c-6.6 0-12-5.4-12-12v-83c0-6.6 5.4-12 12-12h147c6.6 0 12 5.4 12 12v83c0 6.6-5.4 12-12 12",
    style: {
      fill: "url(#lower-banner_svg__SVGID_47_)"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 250.6h-147c-6.6 0-12-5.4-12-12v-83c0-6.6 5.4-12 12-12h147c6.6 0 12 5.4 12 12v83c0 6.6-5.4 12-12 12z",
    className: "lower-banner_svg__st20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m187.2 231.2 29.1-16.9-29.2-17.2-29.2 17.2 29.3 16.9M187.1 197.1l29.3-17.2-29.3-16.9-29.1 16.9 29.1 17.2",
    className: "lower-banner_svg__st60"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m216.4 179.9-.1 34.4-29.2-17.2V163zM158 179.9l29.1 17.2.1 34.1-29.3-16.9z",
    className: "lower-banner_svg__st60"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m187.1 197.1 29.3-17.2-.1 34.4-29.1 16.9zM187.1 163v34.1l-29.2 17.2.1-34.4z",
    className: "lower-banner_svg__st60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_53_",
    x1: 188.662,
    x2: 200.197,
    y1: 195.588,
    y2: 207.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ddcff",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#38b8fe",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m201.7 188.6-.1 17.1-14.4 8.4-.1-17z",
    style: {
      fill: "url(#lower-banner_svg__SVGID_53_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_54_",
    x1: 187.15,
    x2: 187.15,
    y1: 197.11,
    y2: 180.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ddcff",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#38b8fe",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m201.7 188.6-14.6 8.5-14.5-8.5 14.5-8.4z",
    style: {
      fill: "url(#lower-banner_svg__SVGID_54_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lower-banner_svg__SVGID_55_",
    x1: 185.627,
    x2: 174.053,
    y1: 195.597,
    y2: 207.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9ddcff",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#38b8fe",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#05a6fe",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01659c",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m187.2 214.1-14.6-8.4v-17.1l14.5 8.5z",
    style: {
      fill: "url(#lower-banner_svg__SVGID_55_)"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m201.7 188.6-.1 17.1-14.4 8.4-.1-17z",
    className: "lower-banner_svg__st71"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m201.7 188.6-14.6 8.5-14.5-8.5 14.5-8.4z",
    className: "lower-banner_svg__st71"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m187.2 214.1-14.6-8.4v-17.1l14.5 8.5z",
    className: "lower-banner_svg__st71"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lower-banner_svg__cursor"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M965.4 213.5c.2-.2.3-.4.4-.6l1.3-5.6c0 .2-.2.4-.4.6L954 218.6c-.2.2-.3.4-.4.6l-1.3 5.6c0-.2.2-.4.4-.6z",
    className: "lower-banner_svg__st72"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m969.3 238.8-8.6 7.4c-.2.2-.5.3-.7.3-.3 0-.6-.1-.8-.4L943.6 229c-.2-.2-.5-.4-.8-.4s-.5.1-.7.3l-12.6 10.7c-.2.2-.5.3-.7.3-.5 0-.9-.3-1.1-.8l-20.6-59.4q-.15-.3 0-.6l-1.3 5.6v.6l20.6 59.4c.2.5.6.8 1.1.8.3 0 .5-.1.7-.3l12.6-10.7c.2-.2.5-.3.7-.3.3 0 .6.1.8.4l15.4 17.1c.2.2.5.4.8.4s.5-.1.7-.3l8.6-7.4c.2-.2.3-.4.4-.6l1.3-5.6c.1.3 0 .5-.2.6",
    className: "lower-banner_svg__st72"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M908.2 178.3c.2 0 .3 0 .5.1l57.7 27.6c.7.4.9 1.3.3 1.8L954 218.6c-.5.4-.5 1.1-.1 1.6l15.4 17.1c.4.5.4 1.2-.1 1.6l-8.6 7.4c-.2.2-.5.3-.7.3-.3 0-.6-.1-.8-.4L943.6 229c-.2-.2-.5-.4-.8-.4s-.5.1-.7.3l-12.6 10.7c-.2.2-.5.3-.7.3-.5 0-.9-.3-1.1-.8l-20.6-59.4c-.3-.7.3-1.4 1.1-1.4",
    style: {
      fill: "#f29e1f"
    }
  }))));
};
export { SvgLowerBanner as ReactComponent };
export default __webpack_public_path__ + "static/lower-banner.5fb398b6.svg";